import { Colors } from "./Colors"
/**
 * a list of colors to be accessed
 */
export const Fonts={
    supertitle:{
        fontFamily: 'Helvetica',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 18,
        color: '#003F97'
    },
    title:{
        fontSize:16,
        fontWeight:200,
        fontFamily:'Helvetica'
    },
    subtitle:{
        fontFamily:'Helvetica',
        fontStyle:"normal",
        fontSize:12,
        lineHeight:"25px",
        verticalAlign:'bottom',
        color:'#444444'
    },
    text:{
        fontFamily:'Helvetica',
        fontWeight:400,
        fontStyle:"normal",
        fontSize:10
    },
    subtext:{
        fontSize:9,
        fontWeight:400,
        fontFamily:'Helvetica',
        textAlign:'right',
    },
    error:{
        fontSize:9,
        fontWeight:400,
        fontFamily:'Helvetica',
        textAlign:'right',
        color:Colors.red
    },
    faded_label:{
        marginLeft:8,
        verticalAlign: 'middle',
        fontSize:'0.7vw',
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    white_text:{ 
        verticalAlign: 'middle',
        fontSize:10,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#CCC"
    },
}